import { onMounted, onUnmounted } from 'vue'

import type { Proposal } from '@app/application/client_meetings/types'
import type { ProposalGeneratedEvent } from '@app/application/client_meetings/screens/past/events'
import useSfPolling from '@app/shared/vue/composables/use-sf-polling'
import SFetch from '@app/utils/sfetch'
import { useProposalDetailsStore } from '@app/application/client_meetings/screens/past/stores/proposal'

export const useMeetingProposalUpdates = ({
  channelName,
  lastId,
}: {
  channelName: string
  lastId: number
}): void => {
  let stopCompletedPolling: (() => void) | null = null

  const proposalDetailsStore = useProposalDetailsStore()

  async function handleProposalGenerated(
    data: ProposalGeneratedEvent
  ): Promise<void> {
    const proposal = SFetch.camelizeJSON(data.proposal)
    await proposalDetailsStore.addProposalDetails(proposal as Proposal)
  }

  function setupMessageBusSubscription(): void {
    const { startPolling } = useSfPolling<typeof handleProposalGenerated>()

    stopCompletedPolling = startPolling(
      channelName,
      lastId,
      () => true, // Always continue polling
      handleProposalGenerated
    )
  }

  function cleanupMessageBusSubscription(): void {
    if (stopCompletedPolling) {
      stopCompletedPolling()
      stopCompletedPolling = null
    }
  }

  function subscribeToChanges(): void {
    cleanupMessageBusSubscription()
    setupMessageBusSubscription()
  }

  onMounted(() => subscribeToChanges())
  onUnmounted(() => cleanupMessageBusSubscription())
}
